import React from "react";
import MaterialModal from "@material-ui/core/Modal";
import styles from "./modal.module.scss";
import CloseIcon from "@material-ui/icons/Close";
import classNames from "classnames";
import Title from "../title/title";
import { Text } from "components/commons";

const Modal = ({
  active,
  close,
  title,
  titleStyle,
  titleBlack = false,
  subtitle,
  contentStyle,
  textHeaderStyle,
  children,
  closable = true,
  className,
  closeOnDimmer = false,
  removePadding = false,
  style,
  containerStyle,
  headerStyle,
  onClickBody,
  headerExtra, // Optional component to render in header (e.g., filters)
}) => {
  return (
    <MaterialModal
      open={active}
      onClose={closeOnDimmer || closable ? close : null}
      className={classNames(styles.container, containerStyle, {
        [`${styles.removePadding}`]: removePadding,
      })}
    >
      <div style={style} className={classNames(styles.content, className)} onClick={onClickBody}>
        <div className={classNames(styles.header, headerStyle)}>
          <div className={classNames(styles.textHeader, textHeaderStyle)}>
            {title ? (
              <Title small black={titleBlack} className={classNames(styles.title, titleStyle)}>
                {title}
              </Title>
            ) : null}
            {headerExtra && <div className={styles.headerExtra}>{headerExtra}</div>}
            <Text subtitle>{subtitle}</Text>
          </div>
          {closable && (
            <div className={styles.close} onClick={() => close()}>
              <CloseIcon className={styles.icon} />
            </div>
          )}
        </div>
        <div className={classNames(styles.modalContent, contentStyle)}>{children}</div>
      </div>
    </MaterialModal>
  );
};

export default Modal;
